import { formatMoney } from '@/lib/currency.js'
import { zelektor } from '@/lib/utility-functions.js'

export default function (variant, node = document.body) {
    if (variant) {
        const { currentPrice, comparePrice, minPrice } = zelektor(node)
        const { price: currentPriceVal, compare_at_price: comparePriceVal } = variant

        if (variant && minPrice) {
            minPrice.style.display = 'none'
        }

        currentPrice.innerText = formatMoney(currentPriceVal)

        comparePriceVal == '' || !comparePriceVal
            ? (comparePrice.innerText = '')
            : (comparePrice.innerText = formatMoney(comparePriceVal))
    }
}
